const appEnv = {
  PUB_MODE: "r5-staging",
  PUB_API_GATEWAY_ENDPOINT_OPERATION: "https://api.screening-staging.publicserviceplatform.com/ope/r5-security",
  PUB_API_GATEWAY_ENDPOINT_COMMON: "https://api.screening-staging.publicserviceplatform.com/cmn/r5-security",
  PUB_API_GATEWAY_ENDPOINT_EMERGENCY: "https://api.screening-staging.publicserviceplatform.com/eme/r5-security",
  PUB_API_GATEWAY_ENDPOINT_SCREENING: "https://api.screening-staging.publicserviceplatform.com/scr/r5-security",
  PUB_AUTH_ENDPOINT: "https://api.screening-staging.publicserviceplatform.com/auth/r5-security",
  PUB_LGWAN_ENDPOINT_OPERATION: null,
  PUB_LGWAN_ENDPOINT_COMMON: null,
  PUB_LGWAN_ENDPOINT_AUTH: null,
  PUB_LGWAN_ENDPOINT_EMERGENCY: null,
  PUB_LGWAN_ENDPOINT_SCREENING: null,
  PUB_LGWAN_AWS_ENDPOINT_OPERATION: null,
  PUB_LGWAN_AWS_ENDPOINT_COMMON: null,
  PUB_LGWAN_AWS_ENDPOINT_AUTH: null,
  PUB_LGWAN_AWS_ENDPOINT_EMERGENCY: null,
  PUB_LGWAN_AWS_ENDPOINT_SCREENING: null,
  PUB_IDENTITY_POOL_ID: "ap-northeast-1:f0ba74c4-1229-4a3a-8403-cee93fbeab02",
  PUB_USER_POOL_ID: "ap-northeast-1_cOaze6IOc",
  PUB_CLIENT_ID: "88vcb7gekt4a95sob0u0ra8n9",
  PUB_CONTENTS_BUCKET: "disaster-screening-contents-r5-security",
  PUB_CONTENTS_BUCKET_EMERGENCY: "disaster-emergency-contents-r5-security",
  PUB_CONTENTS_BUCKET_SCREENING_GEO_RESULT: "disaster-screening-geo-result-r5-security",
  PUB_S3_BUCKET_ENDPOINT: null,
  PUB_AUTHORIZATION_AUTH_ENDPOINT: null,
  PUB_COGNITO_IDENTITY_ENDPOINT: null,
  PUB_MFA_ENABLE: false
};

export default appEnv;
